import React, { useMemo, useState, createContext, useEffect, } from 'react';
import { getLocation } from '../utils/common';
function getPreview(rcxpv) {
    if (rcxpv === void 0) { rcxpv = ''; }
    return rcxpv ? { rcxpv: rcxpv } : {};
}
function getQueryParam(location, paramKey) {
    if (location === void 0) { location = ''; }
    if (paramKey === void 0) { paramKey = ''; }
    try {
        var url = new URL(location);
        var params = new URLSearchParams(url.search);
        return params.get(paramKey);
    }
    catch (e) {
        return null;
    }
}
function getPreviewParamFromURl(defaultData) {
    if (defaultData === void 0) { defaultData = ''; }
    var rcxpv = getQueryParam(getLocation(), 'rcxpv');
    return rcxpv || defaultData;
}
export var PreviewContext = createContext({});
export function PreviewProvider(_a) {
    var children = _a.children, _b = _a.defaultData, defaultData = _b === void 0 ? '' : _b;
    var _c = useState(getPreviewParamFromURl(defaultData)), preview = _c[0], setPreview = _c[1];
    var previewQuery = useMemo(function () { return getPreview(preview); }, [preview]);
    useEffect(function () {
        var previewParam = getPreviewParamFromURl(defaultData);
        return setPreview(previewParam);
    }, [defaultData]);
    return (React.createElement(PreviewContext.Provider, { value: previewQuery }, children));
}
